import React, { useEffect, useState } from "react";
import { Card, Container, Form, Button } from "react-bootstrap";
import { Spring } from "react-spring/renderprops";
import loader from "../../../assets/images/generate-report-loader.gif";
import "./styles.scss";
import { useHistory } from "react-router-dom";

const ReportLoading = ({
  setStep,
  handleGenerateReport,
  roofData,
  userAddress,
  errorMessage,
  setErrorMessage,
  refCode,
  roofType,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    handleGenerateReport(
      roofData,
      userAddress,

      setErrorMessage,
      refCode,
      setLoading
    );
  }, []);

  return (
    <>
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={{ duration: 1000 }}
      >
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <Card className="pb-5 shadow">
              <div className="loading-card-header-bg sunroof-loading-bg"></div>
              {loading ? (
                <div className="mx-auto p-3 ">
                  <img
                    src={loader}
                    className="loading-gif"
                    alt="loading indicator"
                  />
                </div>
              ) : (
                <>
                  {errorMessage ? (
                    <>
                      <>
                        <div className="error-container">
                          <h3>
                            {" "}
                            We need some more details to provide an accurate
                            estimate!
                          </h3>

                          <p>
                            Please call +1 (800) 401-7716 to have us provide an
                            estimate for you
                          </p>
                        </div>
                      </>
                    </>
                  ) : (
                    <>
                      <div className="success-container">
                        <h3> Successfuly Submited!</h3>

                        <p>
                          We greatly appreciate your valuable time you spent
                          here, please check your Inbox to confirm your Email!
                        </p>
                        <span className="share-link-text">
                          Share the link and get <span> $250</span> in cash, if
                          your referral work with us!
                        </span>

                        <div className="ref-link-input">
                          <span> https://sunfoof.ai/ref?12 </span>
                          <button> Copy</button>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </Card>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default ReportLoading;
